// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ToDo: Each partner should use their own brand colour!*/
.accordion {
    --circle-color: var(--orange)
}

.payment-modal-overlay:has(.page-payment-screen-3-4) {
    background-color: rgba(0, 0, 0, 0.5);
}

.payment-modal:has(.page-payment-screen-3-4) {
    margin: 0 auto;

    border-radius: 24px;
    background-color: var(--white);
}

.payment-modal-overlay .ReactModal__Content--after-open:has(.page-payment-screen-3-4) {
    animation: customEnterModalAnimation 0.5s ease-in-out;
}

.page-payment-screen-3-4 .page-title {
    font-size: 22px;
    font-weight: 600;
    line-height: 26.4px;
    margin: 0 0 40px;
}

.page-payment-screen-3-4 .accordion {
    padding: 24px 16px;
    border-radius: 0;
    background-color: var(--light-gray5);

    border-bottom: 1px solid #F1F3F9;
}

.page-payment-screen-3-4 .accordion .header {
    display: flex;
    justify-content: space-between;
}

.page-payment-screen-3-4 .accordion .body {
    padding-top: 0;
    max-height: inherit;
}

.page-payment-screen-3-4 .accordion.hidden .body {
    max-height: 0;
    padding-top: 0;
}

.page-payment-screen-3-4 .accordion .body .total-container {
    margin: 24px 0;
    display: flex;
    justify-content: space-between;
}

.page-payment-screen-3-4 .accordion .body .total-container .description {
    display: flex;
    align-self: flex-end;

    font-size: 16px;
    font-weight: 800;
    line-height: 19.2px;
    color: black;
}

.page-payment-screen-3-4 .accordion .body .total-container .price-container .crossed-price {
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    text-align: right;

    text-decoration: line-through;
    text-decoration-color: #B1B1B1;
    text-decoration-thickness: 1px;

    color: #B1B1B1;
}

.page-payment-screen-3-4 .accordion .body .total-container .price-container .price {
    margin: 8px 0 0;
    font-size: 16px;
    font-weight: 800;
    line-height: 19.2px;
    color: black;
}

.page-payment-screen-3-4 .accordion .header .wrapper {
    display: flex;
}

.page-payment-screen-3-4 .accordion .header .wrapper span {
    margin-left: 16px;

    font-size: 16px;
    font-weight: 500;
    line-height: 19.2px;
}

.page-payment-screen-3-4 .accordion:not(.hidden) .radio-button {
    background-color: var(--circle-color);
    border: 2px solid var(--circle-color);
    padding: 3px;
    background-clip: content-box;
}

.page-payment-screen-3-4 .radio-button {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    appearance: none;
    cursor: pointer;
    border: 2px solid #A1A3AF;
    background-color: transparent;
}

.page-payment-screen-3-4 .floating-container {
    border-radius: 16px;
    overflow: hidden;
}

.page-payment-screen-3-4 .accordion .header .payment-method-icons {
    margin-top: 3px;

    gap: 4px;
    justify-content: space-between;
}

.page-payment-screen-3-4 .accordion .header .payment-method-icons .icon-container {
    width: 23px;
    height: 16px;
    border: 1px solid var(--light-gray4);
    border-radius: 2.5px;
}

.page-payment-screen-3-4 .accordion .header .payment-method-icons .icon-container.amex {
    background-color: #1F72CD;
}

.page-payment-screen-3-4 .accordion .body .payment-method-icons .icon-container svg {
    width: 17px;
    height: 10px;
    max-width: 100%;
    max-height: 100%;
}

.page-payment-screen-3-4 .accordion .body .stripe-checkout-form-container {
    margin-top: 0;
    padding-top: 24px;
    border-top: 1px solid #F1F3F9;
}

.page-payment-screen-3-4 .accordion .body .stripe-checkout-form-container .button-container {
    margin: 24px 0 0;
}

.page-payment-screen-3-4 .accordion .body .stripe-checkout-form-container .button-container .btn {
    border-radius: 12px;

    font-size: 18px;
    font-weight: 700;
}

.page-payment-screen-3-4 .accordion .body .secure {
    margin-top: 24px;

    font-size: 10px;
    font-weight: 600;
    line-height: 12px;
    text-align: center;
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/payment-screen-v3-4.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;IACI;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;;IAEd,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;;IAEpC,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,oBAAoB;;IAEpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;;IAEjB,6BAA6B;IAC7B,8BAA8B;IAC9B,8BAA8B;;IAE9B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;;IAEjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;;IAEf,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;;IAEhB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":["/* ToDo: Each partner should use their own brand colour!*/\n.accordion {\n    --circle-color: var(--orange)\n}\n\n.payment-modal-overlay:has(.page-payment-screen-3-4) {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n.payment-modal:has(.page-payment-screen-3-4) {\n    margin: 0 auto;\n\n    border-radius: 24px;\n    background-color: var(--white);\n}\n\n.payment-modal-overlay .ReactModal__Content--after-open:has(.page-payment-screen-3-4) {\n    animation: customEnterModalAnimation 0.5s ease-in-out;\n}\n\n.page-payment-screen-3-4 .page-title {\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 26.4px;\n    margin: 0 0 40px;\n}\n\n.page-payment-screen-3-4 .accordion {\n    padding: 24px 16px;\n    border-radius: 0;\n    background-color: var(--light-gray5);\n\n    border-bottom: 1px solid #F1F3F9;\n}\n\n.page-payment-screen-3-4 .accordion .header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.page-payment-screen-3-4 .accordion .body {\n    padding-top: 0;\n    max-height: inherit;\n}\n\n.page-payment-screen-3-4 .accordion.hidden .body {\n    max-height: 0;\n    padding-top: 0;\n}\n\n.page-payment-screen-3-4 .accordion .body .total-container {\n    margin: 24px 0;\n    display: flex;\n    justify-content: space-between;\n}\n\n.page-payment-screen-3-4 .accordion .body .total-container .description {\n    display: flex;\n    align-self: flex-end;\n\n    font-size: 16px;\n    font-weight: 800;\n    line-height: 19.2px;\n    color: black;\n}\n\n.page-payment-screen-3-4 .accordion .body .total-container .price-container .crossed-price {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 16.8px;\n    text-align: right;\n\n    text-decoration: line-through;\n    text-decoration-color: #B1B1B1;\n    text-decoration-thickness: 1px;\n\n    color: #B1B1B1;\n}\n\n.page-payment-screen-3-4 .accordion .body .total-container .price-container .price {\n    margin: 8px 0 0;\n    font-size: 16px;\n    font-weight: 800;\n    line-height: 19.2px;\n    color: black;\n}\n\n.page-payment-screen-3-4 .accordion .header .wrapper {\n    display: flex;\n}\n\n.page-payment-screen-3-4 .accordion .header .wrapper span {\n    margin-left: 16px;\n\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19.2px;\n}\n\n.page-payment-screen-3-4 .accordion:not(.hidden) .radio-button {\n    background-color: var(--circle-color);\n    border: 2px solid var(--circle-color);\n    padding: 3px;\n    background-clip: content-box;\n}\n\n.page-payment-screen-3-4 .radio-button {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    appearance: none;\n    cursor: pointer;\n    border: 2px solid #A1A3AF;\n    background-color: transparent;\n}\n\n.page-payment-screen-3-4 .floating-container {\n    border-radius: 16px;\n    overflow: hidden;\n}\n\n.page-payment-screen-3-4 .accordion .header .payment-method-icons {\n    margin-top: 3px;\n\n    gap: 4px;\n    justify-content: space-between;\n}\n\n.page-payment-screen-3-4 .accordion .header .payment-method-icons .icon-container {\n    width: 23px;\n    height: 16px;\n    border: 1px solid var(--light-gray4);\n    border-radius: 2.5px;\n}\n\n.page-payment-screen-3-4 .accordion .header .payment-method-icons .icon-container.amex {\n    background-color: #1F72CD;\n}\n\n.page-payment-screen-3-4 .accordion .body .payment-method-icons .icon-container svg {\n    width: 17px;\n    height: 10px;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.page-payment-screen-3-4 .accordion .body .stripe-checkout-form-container {\n    margin-top: 0;\n    padding-top: 24px;\n    border-top: 1px solid #F1F3F9;\n}\n\n.page-payment-screen-3-4 .accordion .body .stripe-checkout-form-container .button-container {\n    margin: 24px 0 0;\n}\n\n.page-payment-screen-3-4 .accordion .body .stripe-checkout-form-container .button-container .btn {\n    border-radius: 12px;\n\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.page-payment-screen-3-4 .accordion .body .secure {\n    margin-top: 24px;\n\n    font-size: 10px;\n    font-weight: 600;\n    line-height: 12px;\n    text-align: center;\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
